"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _GridHeader = require("./GridHeader.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridHeader = function GridHeader(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions;
  return /*#__PURE__*/_react.default.createElement(_GridHeader.HeaderView, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "actions"
  }, actions.map(function (action) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "action-button"
    }, action);
  })));
};

exports.GridHeader = GridHeader;

//# sourceMappingURL=GridHeader.js.map